import { useQuery } from "@tanstack/react-query";

import { getAdvisoryCasesId } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import keys from "../keys";

export const useAdvisoryCaseQuery = (
	advisoryCaseId: string | null | undefined,
) => {
	return useQuery({
		queryKey: keys.advisoryCase(advisoryCaseId),
		queryFn: processResponse(() => getAdvisoryCasesId(advisoryCaseId!)),
		enabled: !!advisoryCaseId,
	});
};
